import { createBrowserRouter } from 'react-router-dom';

import { ErrorPage } from '~/pages/error/';
import { NotFoundPage } from '~/pages/not-found';
import { PayPage } from '~/pages/pay';
import { RedirectPage } from '~/pages/redirect';

import { ErrorBoundary } from '../ui/ErrorBoundary/ErrorBoundary';

export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        element: <PayPage />,
      },
      {
        path: '/error',
        element: <ErrorPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
      {
        path: '/redirect',
        element: <RedirectPage />,
      },
    ],
  },
]);
